'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { FC, RefObject } from 'react';
import VimeoPlayer from '@/components/shared/VimeoPlayer';
import css from '../style.module.scss';
import { CasesScrollItemDto } from '../types';
interface Props {
  cases: CasesScrollItemDto[];
  activeIndex: number;
  mediaItemsRef: RefObject<(HTMLDivElement | null)[]>;
  vimeoPlaying: boolean;
}
const CasesSliderMedia: FC<Props> = t0 => {
  const $ = _c(7);
  const {
    cases,
    activeIndex,
    mediaItemsRef,
    vimeoPlaying
  } = t0;
  let t1;
  if ($[0] !== activeIndex || $[1] !== cases || $[2] !== mediaItemsRef || $[3] !== vimeoPlaying) {
    t1 = cases.map((slide, i) => <div key={`${slide.slideTitle}-media-${i}`} ref={el => {
      mediaItemsRef.current[i] = el;
    }} className={css.mediaLayer} aria-hidden={i !== activeIndex}>{slide.videoUrl ? <VimeoPlayer fitCover={true} playing={Boolean(vimeoPlaying && i === activeIndex)} url={slide.videoUrl} thumbnailUrl={slide.videoThumbnailUrl || undefined} className={css.video} /> : slide.image?.url ? <Image className={css.image} width={1600} height={1000} src={slide.image.url} alt={slide.slideTitle || ""} /> : null}</div>);
    $[0] = activeIndex;
    $[1] = cases;
    $[2] = mediaItemsRef;
    $[3] = vimeoPlaying;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className={css.mediaBgCover}>{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default CasesSliderMedia;